var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogosAdminHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 127,
    height: 25,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 23.958h85.867V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "m22.93 13.9.009-3.765-2.573-.008a9.6 9.6 0 0 0-1.332-3.347l1.835-1.908-2.542-2.67-1.846 1.92a8.8 8.8 0 0 0-3.185-1.386L13.303.01 9.698 0l-.007 2.728a8.8 8.8 0 0 0-3.19 1.367L4.662 2.163 2.108 4.82l1.824 1.916a9.6 9.6 0 0 0-1.351 3.341L.01 10.07 0 13.834l2.589.009a9.6 9.6 0 0 0 1.324 3.339L2.07 19.097l2.541 2.67 2.692-2.797v-3.403a5.9 5.9 0 0 1-1.234-3.582c0-3.088 2.421-5.6 5.4-5.6 2.978 0 5.4 2.512 5.4 5.6 0 2.44-1.523 4.5-3.628 5.266v-2.704a3.19 3.19 0 0 0 1.271-2.562c0-1.746-1.362-3.162-3.043-3.162-1.68 0-3.042 1.416-3.042 3.162a3.19 3.19 0 0 0 1.21 2.51v9.463h3.604v-2.715a8.8 8.8 0 0 0 3.198-1.368l1.837 1.93 2.555-2.655-1.823-1.916a9.6 9.6 0 0 0 1.35-3.34z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00C1F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#008EF3"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: "117.4%",
    height: "116.7%",
    x: "-8.7%",
    y: "-4.2%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M34.632 14.889h3.898l-1.94-5.247zm4.152-8.954 5.837 14.368h-4.094l-1.077-2.907h-5.757l-1.098 2.907h-4.093l5.856-14.368z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .46)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M48.033 17.06h1.097c1.39 0 2.31-1.105 2.31-2.68 0-1.7-.88-2.723-2.33-2.723h-1.077zm1.057-8.186c4.858 0 5.896 3.623 5.896 5.506 0 2.108-1.136 5.463-5.896 5.463h-4.464V8.874zm9.603 0 3.583 4.134 3.565-4.134h2.448v10.97h-3.408V14.44c-.822 1.003-1.626 2.006-2.447 2.988h-.335l-2.507-2.988v5.404h-3.329V8.874z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M70.151 19.844h3.408V8.874H70.15zm8.255-10.97 4.054 5.033V8.874h3.406v10.97h-2.8l-4.268-5.383v5.383H75.39V8.874z",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .46)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    fill: "#000",
    filter: "url(#c)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    fill: "url(#e)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosAdminHorizontal);
export default __webpack_public_path__ + "static/media/logos-admin-horizontal.5f55f1ad45e5c46e87759a21d324710f.svg";
export { ForwardRef as ReactComponent };